import { useState } from "react";
import TabLabel from "./TabLabel";
import TabCard from "./TabCard";
import { useColorPalette } from "../../../hooks/useColorPalette";

// Questo componente crea un cartella di elementi selezionabili definendone il layout
// Ogni tab è un elemento dell'array che riceve,
// il quale a sua volta, quando selezionato effettuerà una chiamata per ricevere il rispettivo array di schede
// le quali verranno renderizzate all'interno della propria area
export default function Folder({tabTitleArray, children}) { // children = array di contenuti tab
    const [selectedTab, setSelectedTab] = useState(0);
    const palette = useColorPalette();
    
    return (
        <div className="w-full">
            {/* TAB LINE */}
            <div className="flex">
                {
                    tabTitleArray.map((tab, index) => {
                        return <TabLabel key={index} index={index} selectedTab={selectedTab} setSelectedTab={setSelectedTab} title={tab} />
                    })
                }
            </div>
            {/* AREA TAB SELEZIONATA - senza titoli ripetuti, solo contenuto */}
            <div className="w-full" style={{background: `${palette.primary}20`, minHeight: 120, borderRadius: '0 0 12px 12px', padding: '24px'}}>
                {/* Mostra solo il children della tab selezionata */}
                {Array.isArray(children) ? children[selectedTab] : children}
            </div>
        </div>
    )
} 